export const introductionText = `With over 17,000 pieces of content, there are many ways teachers and students can use Newsela to drive meaningful learning. Based on our conversations, we know you have specific priorities. By answering a few questions, we will be able to configure your teacher’s Newsela experience to ensure that the priorities we’ve discussed are reflected in their experience.`;

export const ADMIN_CONSOLE_CONTENT_PROMOTION_PATHNAME =
  "/admin/content-promotion";
export const CHIRON_CONTENT_PROMOTION_PATHNAME = "/chiron/content-promotion";
export const CHIRON_CONTENT_PROMOTION_PREVIEW_PARAM = "&preview=true";
export enum PATHNAME_FOR_PROMOTED_AT_YOUR_VENUE {
  district = "/your-content/promoted-at-your-district",
  school = "/your-content/promoted-at-your-school",
}

export const ELA_TAXONOMY_DOCUMENT_ID = "clt5v9pa1000058906kihkg33";

export const MEMBER_LIMIT_FOR_REQUEST_FOR_NOVEL_STUDIES_RESPONSES = 999;

export const USER_FEATURE_FOR_PROMOTED_AT_YOUR_DISTRICT_PAGE =
  "can_access_promoted_at_your_district_page";

export const USER_FEATURE_FOR_PROMOTED_AT_YOUR_SCHOOL_PAGE =
  "can_access_promoted_at_your_school_page";

export const USER_FEATURE_TO_CRUD_A_CONTENT_PROMOTION_CONFIGURATION =
  "can_create_and_modify_content_promotion_configurations";
